import React from 'react';
import { Routes, Route } from 'react-router-dom';

import Home from './pages/Home';
import Login from './pages/Login';
import ChangePassword from './pages/ChangePassword'
import Profile from './pages/Profile';
import ForgottenPassword from './pages/ForgottenPassword';
import EmailSent from './pages/EmailSent';
import ResetPassword from './pages/ResetPassword';
import Settings from './pages/Settings';

const Main = () => {
  return (
    <Routes> {/* The Switch decides which component to show based on the current URL.*/}
      <Route path='/main' element={<Home />}></Route>
      <Route path='/change-password' element={<ChangePassword />}></Route>
      <Route path='/profile' element={<Profile />}></Route>
      <Route path='/forgotten-password' element={<ForgottenPassword />}></Route>
      <Route path='/email-sent' element={<EmailSent />}></Route>
      <Route path='/reset-password' element={<ResetPassword />}></Route>
      <Route path='/settings' element={<Settings />}></Route>
      <Route path='/' element={<Login />}></Route>
    </Routes>
  );
}

export default Main;